var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"why-us-item-wrap col-lg mb-3 mb-lg-0",attrs:{"cols":"6"}},[_c('div',{staticClass:"why-us-item-inner"},[_c('b-img',{attrs:{"src":_vm.getIcon,"alt":_vm.getTitle,"fluid":""}}),_c('h3',{domProps:{"innerHTML":_vm._s(_vm.getTitle)}}),_c('hr'),_c('p',[_vm._v(_vm._s(_vm.data.desc))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }